import { Link, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';

interface FindReplacementLinkProps {
    sx?: SxProps;
}

export const FindReplacementLink = ({ sx }: FindReplacementLinkProps) => {
    const { t } = useTranslation();
    const { navigateToMarketplace } = useMarketplaceNavigation();

    return (
        <Link
            data-testid="find-replacement-link"
            component="button"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                navigateToMarketplace({ clearSearch: true });
            }}
            variant="caption"
            sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline',
                },
                ...sx,
            }}
        >
            {t('Find replacement')}
        </Link>
    );
};
